
import $ from 'jquery';
import { Popup } from 'App/popup/popup';

const Social = {
	init: function() {
		$('.js-social-popup').on('click', this._processClick);
	},

	_processClick: function( event ) {
		event.preventDefault();

		const $thisLink = $( this );
		const width = $thisLink.attr( 'data-social-width' ) ? $thisLink.attr( 'data-social-width' ) : 550;
		const height = $thisLink.attr('data-social-height') ? $thisLink.attr('data-social-height') : 450;

		Popup.open( this.href, width, height );
	}
};

export { Social };
